/**
 * Created by xuqingling on 16/5/27.
 */
export default {
    host: "http://www.scwywh.com/",
    dateLocale:  {
        separator: " 至 ",
        format: "YYYY-MM-DD HH:mm:00",
        daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
        monthNames: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
    },
    qiniu: {
        URL: 'wuyan/qiniu/token',
        deleteURL: 'wuyan/qiniu',
        listURL: 'wuyan/qiniu',
        
        wuyan: {
            domain: 'http://img.scwywh.com/'
        },
    }
    
}


// WEBPACK FOOTER //
// ./src/assets/config.js